// The API stores a product image only up to 2 MB (WebUtils.validateImageSize).
export const MAX_PRODUCT_IMAGE_BYTES = 2097152;

// The product itself was saved; one of its images was not uploaded.
export class ProductImageUploadError extends Error {
  constructor(public productId: number, public tooLarge: boolean) {
    super('The product was saved without its image');
  }
}
